import {c as createCommonjsModule, g as getDefaultExportFromCjs} from "../../common/_commonjsHelpers-8c19dec8.js";
import {i as interopRequireDefault} from "../../common/interopRequireDefault-d2c9da36.js";
import {_ as _extends_1, o as objectWithoutPropertiesLoose} from "../../common/defaultTheme-ca6a0b43.js";
import React from "react";
import {p as propTypes} from "../../common/index-877ea290.js";
import {r as require$$3} from "../../common/clsx.m-5dc7436b.js";
import {c as core} from "../../common/index-0a000c27.js";
import {s as styled_1, u as useThemeProps_1} from "../../common/useThemeProps-ef190a94.js";
import {P as Paper} from "../../common/index-ea610a7a.js";
import _jsxRuntime from "react/jsx-runtime";
import "../../common/capitalize-c580b26a.js";
import "../../common/hoist-non-react-statics.cjs-7c8198a1.js";
import "../../common/colorManipulator-ba921df7.js";
import "../../common/useForkRef-edb3fede.js";
import "../../common/emotion-element-99289b21.browser.esm-15d91a3a.js";
import "../../common/useTheme-81ac7d8e.js";
import "../../common/useEventCallback-4c5b62b3.js";
import "../../common/nested-5a43708e.js";
import "../../common/ModalUnstyled-c2fd569c.js";
import "../../common/Portal-3c4bf8a9.js";
import "react-dom";
import "../../common/Popper-131a89f2.js";
import "../../common/useTheme-ad5c2c5a.js";
var cardClasses_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  exports.getCardUtilityClass = getCardUtilityClass;
  function getCardUtilityClass(slot) {
    return (0, core.generateUtilityClass)("MuiCard", slot);
  }
  const cardClasses = (0, core.generateUtilityClasses)("MuiCard", ["root"]);
  var _default = cardClasses;
  exports.default = _default;
});
var Card_1 = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  var _extends2 = interopRequireDefault(_extends_1);
  var _objectWithoutPropertiesLoose2 = interopRequireDefault(objectWithoutPropertiesLoose);
  var React$1 = _interopRequireWildcard(React);
  var _propTypes = interopRequireDefault(propTypes);
  var _clsx = interopRequireDefault(require$$3);
  var _styled = interopRequireDefault(styled_1);
  var _useThemeProps = interopRequireDefault(useThemeProps_1);
  var _Paper = interopRequireDefault(Paper);
  const _excluded = ["className", "raised"];
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
  const useUtilityClasses = (ownerState) => {
    const {
      classes
    } = ownerState;
    const slots = {
      root: ["root"]
    };
    return (0, core.unstable_composeClasses)(slots, cardClasses_1.getCardUtilityClass, classes);
  };
  const CardRoot = (0, _styled.default)(_Paper.default, {
    name: "MuiCard",
    slot: "Root",
    overridesResolver: (props, styles) => styles.root
  })(() => {
    return {
      overflow: "hidden"
    };
  });
  const Card2 = /* @__PURE__ */ React$1.forwardRef(function Card3(inProps, ref) {
    const props = (0, _useThemeProps.default)({
      props: inProps,
      name: "MuiCard"
    });
    const {
      className,
      raised = false
    } = props, other = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);
    const ownerState = (0, _extends2.default)({}, props, {
      raised
    });
    const classes = useUtilityClasses(ownerState);
    return /* @__PURE__ */ (0, _jsxRuntime.jsx)(CardRoot, (0, _extends2.default)({
      className: (0, _clsx.default)(classes.root, className),
      elevation: raised ? 8 : void 0,
      ref,
      ownerState
    }, other));
  });
  var _default = Card2;
  exports.default = _default;
});
var Card = createCommonjsModule(function(module, exports) {
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  var _exportNames = {
    cardClasses: true
  };
  Object.defineProperty(exports, "cardClasses", {
    enumerable: true,
    get: function() {
      return _cardClasses.default;
    }
  });
  Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
      return _Card.default;
    }
  });
  var _Card = interopRequireDefault(Card_1);
  var _cardClasses = _interopRequireWildcard(cardClasses_1);
  Object.keys(_cardClasses).forEach(function(key) {
    if (key === "default" || key === "__esModule")
      return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key))
      return;
    if (key in exports && exports[key] === _cardClasses[key])
      return;
    Object.defineProperty(exports, key, {
      enumerable: true,
      get: function() {
        return _cardClasses[key];
      }
    });
  });
  function _getRequireWildcardCache(nodeInterop) {
    if (typeof WeakMap !== "function")
      return null;
    var cacheBabelInterop = new WeakMap();
    var cacheNodeInterop = new WeakMap();
    return (_getRequireWildcardCache = function(nodeInterop2) {
      return nodeInterop2 ? cacheNodeInterop : cacheBabelInterop;
    })(nodeInterop);
  }
  function _interopRequireWildcard(obj, nodeInterop) {
    if (!nodeInterop && obj && obj.__esModule) {
      return obj;
    }
    if (obj === null || typeof obj !== "object" && typeof obj !== "function") {
      return {
        default: obj
      };
    }
    var cache = _getRequireWildcardCache(nodeInterop);
    if (cache && cache.has(obj)) {
      return cache.get(obj);
    }
    var newObj = {};
    var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
    for (var key in obj) {
      if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
        var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
        if (desc && (desc.get || desc.set)) {
          Object.defineProperty(newObj, key, desc);
        } else {
          newObj[key] = obj[key];
        }
      }
    }
    newObj.default = obj;
    if (cache) {
      cache.set(obj, newObj);
    }
    return newObj;
  }
});
var __pika_web_default_export_for_treeshaking__ = /* @__PURE__ */ getDefaultExportFromCjs(Card);
export default __pika_web_default_export_for_treeshaking__;
